
import Vue, { PropType } from 'vue';
import { minLength, required } from 'vuelidate/lib/validators';
import Modal from '@/components/modal/Modal.vue';
import { Validation } from 'vuelidate/vuelidate';
import { Device, DeviceAreaEdit, DeviceEdit, Floor } from '@/interfaces/locations';
import { SelectMenu } from '@/interfaces/global';

interface GatewayForm {
	name: string;
	description: string;
	floor: number | null;
}

export default Vue.extend({
	components: {
		Modal,
	},
	data(): { gatewayForm: GatewayForm } {
		return {
			gatewayForm: {
				name: '',
				description: '',
				floor: null,
			},
		};
	},
	props: {
		oldGateway: Object as PropType<Device | null>,
		floors: Array as PropType<Floor[]>,
	},

	validations: {
		gatewayForm: {
			name: {
				required,
				minLength: minLength(3),
			},
			description: {},
			floor: {},
		},
	},
	created(): void {
		if (this.oldGateway !== null) {
			this.gatewayForm = {
				name: this.oldGateway.name,
				description: this.oldGateway.description,
				floor: this.oldGateway?.fk_area ?? null,
			};
		} else {
			this.resetGatewayModal();
		}
	},
	computed: {
		floorOptions(): SelectMenu[] {
			const floorSelection: SelectMenu[] = [{ value: null, text: this.$i18n.t('None') }];
			for (const floor of this.floors) {
				floorSelection.push({ value: floor.id, text: floor.name });
			}
			return floorSelection;
		},
	},
	watch: {
		oldGateway: {
			deep: true,
			handler() {
				if (this.oldGateway !== null) {
					this.gatewayForm = {
						name: this.oldGateway.name,
						description: this.oldGateway.description,
						floor: this.oldGateway?.fk_area ?? null,
					};
				} else {
					this.resetGatewayModal();
				}
			},
		},
	},

	methods: {
		resetGatewayModal() {
			if (this.oldGateway !== null) {
				this.gatewayForm = {
					name: this.oldGateway.name,
					description: this.oldGateway.description,
					floor: this.oldGateway?.fk_area ?? null,
				};
			} else {
				this.gatewayForm = {
					name: '',
					description: '',
					floor: null,
				};
			}
			this.$v.gatewayForm.$reset();
		},

		async confirmGatewayModal() {
			this.$v.gatewayForm.$touch();

			if (this.$v.gatewayForm.$anyError) {
				return;
			}

			let newGateway: DeviceEdit = {
				name: this.gatewayForm.name,
				description: this.gatewayForm.description,
				attrs: { serial_number: this.gatewayForm.name },
			};
			let newDeviceArea: DeviceAreaEdit | undefined = undefined;

			if (this.oldGateway !== null) {
				if (this.gatewayForm.floor !== null) {
					newDeviceArea = {
						fk_area: this.gatewayForm.floor,
						fk_device: this.oldGateway.id,
					};
				}
				this.$emit('modifyGateway', this.oldGateway.id, newGateway, newDeviceArea);
			} else {
				if (this.gatewayForm.floor !== null) {
					newDeviceArea = {
						fk_area: this.gatewayForm.floor,
						fk_device: null,
					};
				}
				this.$emit('addGateway', newGateway, newDeviceArea);
			}
		},

		validateState(validation: Validation): boolean | null {
			const { $dirty, $error }: { $dirty: boolean; $error: boolean } = validation;
			return $dirty ? !$error : null;
		},

		closeGatewayModal(): void {
			this.$bvModal.hide('modal-gateway');
		},
	},
});
